import { takeLatest, put, call } from "redux-saga/effects";
import BackendClient from "api/backend-client";
import { RecipeScalingApiMethods } from "api/api-methods";
import { waitForLogin } from "../auth/auth.saga";
import { loadProcessDataListFailure, loadProcessDataListSuccessful, ProcessDataListActionType, } from "./process-data-list.actions";
import { apiErrorHandler } from "store/global/global.saga";
export function* loadProcessDataListSaga() {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        const data = yield call([
            backendClient,
            RecipeScalingApiMethods.GetProcessDataList,
        ]) || [];
        yield put(loadProcessDataListSuccessful(data));
    }
    catch (e) {
        yield call(apiErrorHandler, e, "process data list load failed");
        yield put(loadProcessDataListFailure());
    }
}
export default function* processDataListSaga() {
    yield takeLatest(ProcessDataListActionType.LOAD_LIST, loadProcessDataListSaga);
}
